import React from 'react';
import { Container } from '../components/ui/Container';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { BookOpen, FileText, Video, Download } from 'lucide-react';
export function ResourcesPage() {
  const guides = [{
    title: 'Getting Started with Flowsense',
    description: 'Learn how to connect your Klaviyo account and run your first flow analysis in under 5 minutes.',
    icon: BookOpen,
    category: 'Guide',
    readTime: '5 min read'
  }, {
    title: 'Understanding Flow Health Scores',
    description: 'Deep dive into how we calculate health scores and what each metric means for your flows.',
    icon: FileText,
    category: 'Guide',
    readTime: '8 min read'
  }, {
    title: 'Implementing AI Recommendations',
    description: 'Best practices for prioritizing and implementing recommendations to maximize ROI.',
    icon: BookOpen,
    category: 'Guide',
    readTime: '10 min read'
  }, {
    title: 'Agency White-Label Setup',
    description: 'Complete guide to setting up custom domains and branded reports for your agency clients.',
    icon: FileText,
    category: 'Guide',
    readTime: '12 min read'
  }, {
    title: 'Flow Optimization Playbook',
    description: 'Proven strategies for optimizing Welcome, Abandonment, and Post-Purchase flows.',
    icon: Download,
    category: 'Template',
    readTime: 'PDF Download'
  }, {
    title: 'ROI Reporting Template',
    description: 'Ready-to-use spreadsheet template for tracking and reporting flow optimization ROI.',
    icon: Download,
    category: 'Template',
    readTime: 'Excel Download'
  }];
  return <div className="bg-white" data-id="element-484">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-485">
        <Container data-id="element-486">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-487">
            Resources & Guides
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-488">
            Everything you need to master flow optimization and maximize your
            Klaviyo ROI.
          </p>
        </Container>
      </div>

      {/* Guides Grid */}
      <section className="py-24" data-id="element-489">
        <Container data-id="element-490">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-491">
            {guides.map((guide, index) => <Card key={index} className="hover:shadow-lg transition-shadow" data-id="element-492">
                <CardContent className="p-6" data-id="element-493">
                  <div className="flex items-center justify-between mb-4" data-id="element-494">
                    <div className="p-2 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-lg" data-id="element-495">
                      <guide.icon className="h-6 w-6 text-white" data-id="element-496" />
                    </div>
                    <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-497">
                      {guide.category}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-498">
                    {guide.title}
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-499">{guide.description}</p>
                  <div className="flex items-center justify-between" data-id="element-500">
                    <span className="text-sm text-gray-500" data-id="element-501">
                      {guide.readTime}
                    </span>
                    <Button variant="link" className="p-0 h-auto" data-id="element-502">
                      Read More →
                    </Button>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </Container>
      </section>

      {/* CTA */}
      <section className="py-24 bg-gray-900" data-id="element-503">
        <Container data-id="element-504">
          <div className="text-center max-w-3xl mx-auto" data-id="element-505">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-506">
              Ready to Start Optimizing?
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-507">
              Put these guides into action with Flowsense.
            </p>
            <a href="https://app.useflowsense.com/auth/signup" data-id="element-508">
              <Button size="lg" data-id="element-509">Sign Up</Button>
            </a>
          </div>
        </Container>
      </section>
    </div>;
}